import './woocommerce/css/woocommerce-layout.scss';
import './woocommerce/css/woocommerce-smallscreen.scss';
import './woocommerce/css/woocommerce.scss';
import './woocommerce/css/woocommerce-blocktheme.scss';